export const BOOKING_CREATE_REQUEST = 'booking/auth/create-request'
export const BOOKING_CREATE_SUCCESS = 'booking/auth/create-success'
export const BOOKING_CREATE_FAILED = 'booking/auth/create-failed'
